import React, { useContext } from 'react';
import {
	IDeviceFullInfoContext,
	DeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { useTranslation } from 'react-i18next';
import style from './UseTLSCertificateField.module.scss';

export const UseTLSCertificateField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = deviceForFullInfo?.useTlsCertificate;

	const inputValue = t(
		deviceForFullInfo?.tlsCertificateLevel === 'Device'
			? 'useCertificateForDevicesIndividually'
			: 'clientTLSCertificateUsedLabel',
	);

	return (
		<FullInfoField
			containerClassName={style.containerClassName}
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
